'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _iBem = require('../../i-bem/i-bem.react');

var _iBem2 = _interopRequireDefault(_iBem);

var _bTickerEValue = (require('./../__value/ticker__value.react.js').default || require('./../__value/ticker__value.react.js')).applyDecls();

var _bTickerEValue2 = _interopRequireDefault(_bTickerEValue);

var _eTextTI18n = function () {
    var core = require('bem-i18n');

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'ru' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'ru' : 'en' === 'ru') {
        return core().decl(require('./../__text/ticker__text.i18n/ru'))('ticker__text');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'en' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'en' : 'en' === 'en') {
        return core().decl(require('./../__text/ticker__text.i18n/en'))('ticker__text');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'be' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'be' : 'en' === 'be') {
        return core().decl(require('./../__text/ticker__text.i18n/be'))('ticker__text');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'id' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'id' : 'en' === 'id') {
        return core().decl(require('./../__text/ticker__text.i18n/id'))('ticker__text');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'kk' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'kk' : 'en' === 'kk') {
        return core().decl(require('./../__text/ticker__text.i18n/kk'))('ticker__text');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'tr' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'tr' : 'en' === 'tr') {
        return core().decl(require('./../__text/ticker__text.i18n/tr'))('ticker__text');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'tt' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'tt' : 'en' === 'tt') {
        return core().decl(require('./../__text/ticker__text.i18n/tt'))('ticker__text');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'uk' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'uk' : 'en' === 'uk') {
        return core().decl(require('./../__text/ticker__text.i18n/uk'))('ticker__text');
    }

    if (process.env.NODE_ENV === 'development') {
        process.env.BEM_LANG && console.error('No match of process.env.BEM_LANG { ' + process.env.BEM_LANG + ' } in provided langs: { ru, en, be, id, kk, tr, tt, uk }');
        process.env.REACT_APP_BEM_LANG && console.error('No match of process.env.REACT_APP_BEM_LANG { ' + process.env.REACT_APP_BEM_LANG + ' } in provided langs: { ru, en, be, id, kk, tr, tt, uk }');
    }

    return function () {};
}();

var _eTextTI18n2 = _interopRequireDefault(_eTextTI18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _iBem.decl)({
    block: 'ticker',
    elem: 'count',
    tag: function tag(_ref) {
        var url = _ref.url;

        return url ? 'a' : 'span';
    },
    attrs: function attrs(_ref2) {
        var href = _ref2.url;

        return { href: href };
    },
    content: function content(_ref3) {
        var url = _ref3.url,
            count = _ref3.count,
            maxCount = _ref3.maxCount;
        var block = this.block,
            mix = this.props.mix;


        return [_react2.default.createElement(
            _iBem2.default,
            { key: 'text', block: block, elem: 'text',
                mix: { block: 'a11y-hidden' } },
            (0, _eTextTI18n2.default)('notifications')
        ), _react2.default.createElement(_bTickerEValue2.default, _extends({ key: 'value' }, { count: count, maxCount: maxCount, mix: !url && [{ block: block, elem: 'plain' }, mix] }))];
    }
}, {
    propTypes: {
        url: _propTypes2.default.string,
        count: _propTypes2.default.number,
        maxCount: _propTypes2.default.number
    },
    defaultProps: {
        count: 0,
        maxCount: 99
    }
});